import { render, staticRenderFns } from "./PassoRegistro.vue?vue&type=template&id=54463240&"
import script from "./PassoRegistro.vue?vue&type=script&lang=js&"
export * from "./PassoRegistro.vue?vue&type=script&lang=js&"
import style0 from "./PassoRegistro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports